module.exports = __webpack_public_path__ + "img/language_border.70545108.svg";